import { ContentCluster } from '@app/components/base/content-structure/ContentCluster';
import { useImpersonation } from '../hooks/useImpersonationStore';
import { impersonationMessages } from '../impersonation-messages';
import { ImpersonationUserListItem } from './ImpersonationUserListItem';

/**
 * Cluster showing the persisted (localStorage) impersonated user for this browser.
 */
export function CurrentImpersonatedUserCard() {
  const { impersonatedUser } = useImpersonation();

  if (!impersonatedUser) {
    return null;
  }

  return (
    <ContentCluster message={impersonationMessages.currentUserTitle}>
      <ImpersonationUserListItem user={impersonatedUser} sx={{ px: 0 }} />
    </ContentCluster>
  );
}
